import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import Error from '../../Components/UiErrorComponents/Error';
import VideoLoading from '../../Components/UiLoadingComponents/VideoLoading';
import { useGetSingleVideoQuery } from '../../features/videos/videosApi';
import VideoDetailsAndPlayer from './VideoDetailsAndPlayer';

const VideoContainer = () => {
    const { id } = useParams()
    const { data, isLoading, isError, error } = useGetSingleVideoQuery(id)

    // dose it has any 

    return (
        <>
            {
                isLoading ? <div>
                    <VideoLoading></VideoLoading>
                </div> : <>
                    {
                        !isError ? <VideoDetailsAndPlayer {...data}></VideoDetailsAndPlayer>

                            : <div>
                                <Error error="Video Not Found! "></Error>
                            </div>
                    }


                </>
            }
        </>
    );
};

export default VideoContainer;